import { FC, useContext, useMemo } from 'react';

import {
  GroupedCoverageCardsList,
} from '../../../../../shared';
import { ContentSection } from '../../../../../../../../../shared/components';

import { GenericDataFormContext, QuotationInfoContext } from '../../../../../shared/contexts';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';

import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';

interface CoveragesConsortiumSectionProps {
  tabKey: number;
}

export const CoveragesConsortiumSection: FC<
  CoveragesConsortiumSectionProps
> = ({ tabKey }) => {
  const { stepThreeConsortiumQuotationForm } = useContext(StepThreeFormContext);
  const { stepTwoForm } = useContext(StepTwoFormContext);
  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);
  const { quotationInfo } = useContext( QuotationInfoContext );

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const allCoverages = useMemo(
    () => allCoveragesPerPlan.find(
      el => (el.plan as string) === String(planSelected)
    )?.coverages, 
    [allCoveragesPerPlan, planSelected]
  );

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
    useMemo(() => {
      return allCoverages
        ? groupCardsByCommonSection(allCoverages, 'codigoFamilia')
        : {};
    }, [allCoverages]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`consortium-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeConsortiumQuotationForm}
              allCoveragesByTabList={allCoverages ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`consortium-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeConsortiumQuotationForm}
              allCoveragesByTabList={allCoverages ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}
    </ContentSection>
  );
};
